module.exports = __webpack_public_path__ + "img/banner.312cd671.png";